<template>
  <Drawer title="新建基础配置" :value="value" @input="value => $emit('input', value)" width="520" :mask-closable="false"
    :styles="styles">
    <div class="drawer-content">
      <span>基础配置</span>
      <div>
        用户标签组:
        <el-select v-model="formData.userSign" placeholder="请选择" size="small" v-el-select-loadmore="loadMore">
          <el-option v-for="(item, index) in signList" :key="`${item.name}-${index}`" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
      </div>
      <el-divider></el-divider>
      <div>
        规则优先级:
        <el-input v-model="formData.priorityLevel" style="width: 200px;" size="small"></el-input>
      </div>
      <el-divider></el-divider>
      <div>
        用户类型:
        <el-select v-model="formData.userType" placeholder="请选择" size="small">
          <el-option label="用户 male" :value="0"></el-option>
          <el-option label="主播 female" :value="1"></el-option>
        </el-select>
      </div>
      <div class="dash-box">
        <div>匹配价格</div>
        <template v-if="formData.userType === 0">
          <div class="form-item">
            both<el-input v-model="formData.bothPrice" style="width: 200px;" size="small"></el-input>金币
          </div>
          <div class="form-item">
            男性<el-input v-model="formData.manPrice" style="width: 200px;" size="small"></el-input>金币
          </div>
          <div class="form-item">
            女性<el-input v-model="formData.femalePrice" style="width: 200px;" size="small"></el-input>金币
          </div>
        </template>
        <div class="form-item" v-else>
          <el-input v-model="formData.hostMatchEarn" style="width: 200px;" size="small"></el-input>钻石
        </div>
        <el-divider></el-divider>
        <div>匹配上限</div>
        <template v-if="formData.userType === 0">
          <div class="form-item">
            both<el-input v-model="formData.bothMaxTimes" style="width: 200px;" size="small"></el-input>次
          </div>
          <div class="form-item">
            男性<el-input v-model="formData.manMaxTimes" style="width: 200px;" size="small"></el-input>次
          </div>
          <div class="form-item">
            女性<el-input v-model="formData.femaleMaxTimes" style="width: 200px;" size="small"></el-input>次
          </div>
        </template>
        <div class="form-item" v-else>
          <el-input v-model="formData.hostMatchMaxTimes" style="width: 200px;" size="small"></el-input>次
        </div>
        <el-divider></el-divider>
        <div>匹配时间配置</div>
        <div class="form-item">
          挂断时间<el-input v-model="formData.canHangUpDuration" style="width: 200px;" size="small"></el-input>秒
        </div>
        <div class="form-item">
          通话时间<el-input v-model="formData.maxChatDuration" style="width: 200px;" size="small"></el-input>秒
        </div>
        <div class="form-item">
          匹配间隔时间<el-input v-model="formData.matchInterval" style="width: 200px;" size="small"></el-input>秒
        </div>
        <div class="form-item" v-if="formData.userType === 1">
          倒计时触发时间<el-input v-model="formData.countdownTriggerTime" style="width: 200px;" size="small"></el-input>秒
        </div>
        <el-divider></el-divider>
        <template v-if="formData.userType === 0">
          <div>免费匹配次数配置</div>
          <div class="form-item">
            新手礼包匹配券<el-input v-model="formData.newUserMatchTimes" style="width: 200px;" size="small"></el-input>张
          </div>
          <el-divider></el-divider>
        </template>
        <template v-if="formData.userType === 0">
          <div>匹配券配置</div>
          <div class="match-ticket-box" v-for="(outerItem, outerInd) in formData.usualMatchTimesConfigBO.configList"
            :key="outerInd">
            <i class="el-icon-error" @click="listRemove(false, outerInd)"></i>
            <div class="form-item">
              登录行为<el-input v-model="formData.usualMatchTimesConfigBO.configList[outerInd].startDay"
                style="width: 100px;" size="small"></el-input>至
              <el-input v-model="formData.usualMatchTimesConfigBO.configList[outerInd].endDay" style="width: 100px;"
                size="small"></el-input>天
            </div>
            <div class="form-item" v-for="(innerItem, innerInd) in outerItem.usualMatchTimesReceiveConfigList"
              :key="innerInd">
              第<el-input
                v-model="formData.usualMatchTimesConfigBO.configList[outerInd].usualMatchTimesReceiveConfigList[innerInd].matchReceiveTimes"
                style="width: 90px;" size="small"></el-input>次领取匹配券
              <el-input
                v-model="formData.usualMatchTimesConfigBO.configList[outerInd].usualMatchTimesReceiveConfigList[innerInd].matchReceiveNums"
                style="width: 90px;" size="small"></el-input>张
              <br>
              <div style="display: flex;justify-content: center; align-items: center;margin-top: 6px;">
                领取时间
                <el-input
                  v-model="formData.usualMatchTimesConfigBO.configList[outerInd].usualMatchTimesReceiveConfigList[innerInd].matchReceiveCountdown"
                  style="width: 90px;" size="small"></el-input> 秒 <i class="el-icon-remove"
                  @click="listRemove(true, outerInd, innerInd)"></i>
              </div>
            </div>
            <el-button type="success" icon="el-icon-plus" circle @click="listAdd(true, outerInd)"></el-button>
          </div>
          <el-button type="success" icon="el-icon-plus" circle @click="listAdd(false)"></el-button>
        </template>
      </div>
    </div>
    <div class="drawer-footer">
      <Button style="margin-right: 8px" @click="$emit('input', false)">取消</Button>
      <Button type="primary" @click="$emit('save', tranObjToSubmit())">保存</Button>
    </div>
  </Drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object
    },
    signList: {
      type: Array
    }
  },
  data() {
    return {
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      formData: {

      }
    }
  },
  watch: {
    config: {
      immediate: true,
      handler(val) {
        val.usualMatchTimesConfigBO.configList = this.submitToShow(val.usualMatchTimesConfigBO.configList)
        this.formData = val

      }
    }
  },
  methods: {
    loadMore(){
      this.$emit("loadMore")
    },
    // isInner 是否内部增加
    listAdd(isInner, ind) {
      if (isInner) {
        console.log(this.formData.usualMatchTimesConfigBO.configList);
        this.formData.usualMatchTimesConfigBO.configList[ind].usualMatchTimesReceiveConfigList.push({
          matchReceiveTimes: 0,
          matchReceiveNums: 0,
          matchReceiveCountdown: 0
        })
      } else {
        this.formData.usualMatchTimesConfigBO.configList.push({
          dayInterval: '',
          usualMatchTimesReceiveConfigList: [
            {
              matchReceiveTimes: 0,
              matchReceiveNums: 0,
              matchReceiveCountdown: 0
            }
          ]
        })
      }
    },
    // isInner 是否内部删除
    listRemove(isInner, outerInd, ind) {
      if (isInner) {
        if (this.formData.usualMatchTimesConfigBO.configList[outerInd].usualMatchTimesReceiveConfigList.length === 1) return
        this.formData.usualMatchTimesConfigBO.configList[outerInd].usualMatchTimesReceiveConfigList.splice(ind, 1)
      } else {
        if (this.formData.usualMatchTimesConfigBO.configList.length === 1) return
        this.formData.usualMatchTimesConfigBO.configList.splice(outerInd, 1)
      }
    },
    submitToShow(arr) {
      return arr.map(item => {
        let copyItem = JSON.parse(JSON.stringify(item))
        if (!copyItem.dayInterval) {
          copyItem.startDay = ''
          copyItem.endDay = ''
        } else {
          const chars = copyItem.dayInterval.split(',');
          copyItem.startDay = chars[0]
          copyItem.endDay = chars[1]
        }
        return copyItem
      })
    },
    arrayToSubmit(arr) {
      console.log(arr);
      return arr.map(item => {
        let copyItem = JSON.parse(JSON.stringify(item))
        copyItem.dayInterval = copyItem.startDay + ',' + copyItem.endDay
        delete copyItem.startDay
        delete copyItem.endDay
        return copyItem
      })
    },
    tranObjToSubmit() {
      let obj = JSON.parse(JSON.stringify(this.formData))
      obj.usualMatchTimesConfigBO.configList = this.arrayToSubmit(obj.usualMatchTimesConfigBO.configList)
      obj.usualMatchTimesConfig = JSON.stringify(obj.usualMatchTimesConfigBO)
      return obj
    }
  },
  directives: {
    'el-select-loadmore': (el, binding) => {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(
        '.el-select-dropdown .el-select-dropdown__wrap'
      )
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) binding.value()
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.drawer-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .dash-box {
    width: 100%;
    border: 2px dashed #eee;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    padding: 10px;

    .form-item {
      padding: 6px;

      .el-input {
        margin: 0 10px;
      }
    }
  }
}

.drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}

.match-ticket-box {
  width: 100%;
  border-radius: 14px;
  background-color: #eee;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
  padding: 10px 0;

  >i {
    position: absolute;
    top: -5px;
    right: -4px;
    cursor: pointer;
    font-size: 24px;

    &:hover {
      color: #ef696c;
    }
  }

  .el-icon-remove {
    font-size: 20px;
    cursor: pointer;
    vertical-align: -2px;

    &:hover {
      color: #ef696c;
    }
  }
}
</style>